
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class EmployeeAdvanceGrid extends Serenity.EntityGrid<EmployeeAdvanceRow, any> {
        protected getColumnsKey() { return 'HR.EmployeeAdvance'; }
        protected getDialogType() { return EmployeeAdvanceDialog; }
        protected getIdProperty() { return EmployeeAdvanceRow.idProperty; }
        protected getInsertPermission() { return EmployeeAdvanceRow.insertPermission; }
        protected getLocalTextPrefix() { return EmployeeAdvanceRow.localTextPrefix; }
        protected getService() { return EmployeeAdvanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}